var _polygon, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 648,
    height: 768,
    viewBox: "-2.84688012 -2.84688012 100.58976424 119.29476024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "0.1679,113.8535 0.1679,113.8535 95.0639,113.8535 95.0639,0.2525 0.1679,0.2525 ",
    transform: "translate(-0.1679,-0.2525)",
    fill: "#007cba",
    id: "fda-square"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 79.691,53.664 -8.016,-24.093 -3.853,11.339 4.332,0 1.566,5.447 -7.626,0 -2.524,7.307 -7.086,0 11.869,-31.621 6.289,0 11.869,31.621 -6.82,0 z M 48.078,52.645 c -2.038,0.681 -4.34,1.019 -6.909,1.019 l -10.718,0 0,-18.661 6.599,0 0,13.036 4.252,0 c 1.712,0 3.173,-0.244 4.384,-0.73 1.211,-0.488 2.192,-1.188 2.946,-2.104 0.752,-0.916 1.306,-1.999 1.66,-3.254 0.355,-1.256 0.532,-2.665 0.532,-4.23 0,-1.536 -0.155,-2.932 -0.465,-4.186 -0.31,-1.255 -0.805,-2.31 -1.484,-3.166 -0.68,-0.856 -1.558,-1.52 -2.635,-1.994 -0.944,-0.413 -2.108,-0.611 -3.425,-0.665 l -26.749,0 0,7.243 8.902,0 0,5.669 -8.902,0 0,13.042 -6.599,0 0,-31.622 20.984,0 13.007,0 c 4.272,0.203 7.658,1.535 10.134,3.942 2.701,2.627 4.052,6.525 4.052,11.692 0,2.627 -0.376,4.931 -1.129,6.908 -0.753,1.979 -1.839,3.647 -3.256,5.005 -1.417,1.359 -3.144,2.377 -5.181,3.056 l 0,0 0,0 0,0 z",
    id: "polygon3057",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFda);
export default __webpack_public_path__ + "static/media/fda.aae4e3b8dff8b3e6144f1d2fe1c7e1f6.svg";
export { ForwardRef as ReactComponent };